module.exports = new __parcel__URL__("horse_thumb.05bb41a5.jpg").toString();